// doesnt work with date format "22-01-2022". day with two digits first

export const DateFormatter = (input: string | Date | undefined | null ) : string => {
    if(!input) return ""
    
    let date = new Date(input)
    let day = ("0" + date.getDate()).slice(-2)
    let month = ("0"+(date.getMonth()+1)).slice(-2)
    let year = date.getFullYear()
    let formattedDate = day + "-" + month + "-" + year

   return formattedDate.toString() // Return date format DD-MM-YYYY

}

export const DateFormatterWithTime = (input: string | Date | undefined | null ) : string => {
    if(!input) return ""
    
    let date = new Date(input)
    let day = ("0" + date.getDate()).slice(-2)
    let month = ("0"+(date.getMonth()+1)).slice(-2)
    let year = date.getFullYear()
    let hour = ("0" + date.getHours()).slice(-2) 
    let mins = ("0" + date.getMinutes()).slice(-2)
    let formattedDate = `${day}-${month}-${year} ${hour}:${mins}`
    return formattedDate.toString() // Return date format DD-MM-YYYY

}